import React from 'react';

import { H3, HStack } from '@betterment/samba-react';

import AiOrb from '../assets/icon_ai_orb.svg';

export const ExplanationHeading: React.FC = () => (
  <HStack css={{ gap: 'space.100', alignItems: 'center' }}>
    <img src={AiOrb} alt="AI Icon" width="20px" height="20px" />
    <H3 variant="title100" color="text">
      Why this makes sense for you
    </H3>
  </HStack>
);
